import { HttpContextToken } from '@angular/common/http';

// impostato dal chiamante (HttpContext) su singole richieste che non devono accendere lo spinner
// globale — alternativa a un elenco di stringhe URL nell'interceptor, che si romperebbe per
// endpoint la cui url è configurabile da DB e quindi non garantita uguale in ogni ambiente/cliente
// (vedi MapService._authenticatedTileLoader, tile mappa via /map/proxy)
export const SKIP_LOADING_SPINNER = new HttpContextToken<boolean>(() => false);
